'use strict';
(function () {
  angular.module('pentaApp').factory('storeUtils', service);
  service.$inject = [];
  function service() {
    return {
      filterBuyMessage: filterBuyMessage,
      doesMatch: doesMatch,
      showBuyMessage: showBuyMessage
    }
    //////

    // Esta función devuelve un array de alertas filtradas por un momento especifico.
    function filterBuyMessage(alerts, moment) {
      if (!alerts || !alerts.length || !moment) return [];
      var data = alerts.filter(function (f) { return f.moment.find(function (k) { return k === moment }) })
      return data
    }

    // Esta función devuelve true o false si matchea o no
    function doesMatch(order, itemAlert) {
      if (!order || !itemAlert || !itemAlert.match) return false;
      // Variables de la orden.
      var products = order.products;

      // Variables para verificar el matching.
      var productCategories = itemAlert.match.productCategories;
      var checkoutMethods = itemAlert.match.checkoutMethods;
      var paymentMethods = itemAlert.match.paymentMethods;

      // Devuelve true si hay matching entre la orden y el alert.
      if (productCategories.length) //- Categorias.
        if (!validateProductCategory(products, productCategories)) return false
      if (checkoutMethods.length) //- Metodo de entrega.
        if (!checkoutMethods.find(function (f) { return f === order.checkoutMethod })) return false;
      if (paymentMethods.length) {//- Metodos de pago.
        if (order.cash && !paymentMethods.find(function (f) { return f === 'CASH' })) return false;
        if (!order.cash && !paymentMethods.find(function (f) { return f === 'DIGITAL' })) return false;
      }
      return true
    }

    function validateProductCategory(products, productCategories) {
      var result = false;
      products.forEach(function (product) {
        if (result || !product.properties || !product.properties.categories) return
        product.properties.categories.forEach(function (category) {
          if (productCategories.indexOf(category._id) >= 0) result = true;
        })
      })
      return result
    }

    function showBuyMessage(data) {//- Mostrar alerta
      if (!data.text) return
      ons.notification.alert({ message: data.text, title: i18next.t('Atención') });
    }
  }
})();